// All new components must import useTranslation and use t() for UI strings
import React from 'react';
import ConfirmDialog from '../../../components/ui/ConfirmDialog';
import useTranslation from '../../../hooks/useTranslation';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, projectName }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      confirmVariant="danger"
      title={t('deleteModal.title')}
      message={t('deleteModal.message')}
      confirmLabel={t('deleteModal.delete')}
      cancelLabel={t('deleteModal.cancel')}
      onConfirm={handleConfirm}
      onCancel={onClose}
    >
      {projectName && (
        <div className="mt-2 p-3 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 mb-1">{t('deleteModal.projectLabel')}</p>
          <p className="text-sm font-medium text-gray-900">{projectName}</p>
        </div>
      )}
    </ConfirmDialog>
  );
};

export default DeleteConfirmationModal;